import { Not } from "typeorm";
import { TenantEntity, TenantStatus, } from "../../entities/tenant.js";
export const listTenants = {
    name: "listTenants",
    description: "Returns all tenants that are not soft-deleted",
    type: "query",
    isAuthRequired: true,
    useCase: async ({ db }) => {
        const tenants = await db.find(TenantEntity, {
            where: { status: Not(TenantStatus.DELETED) },
        });
        return tenants;
    },
};
